import { render, staticRenderFns } from "./EditorIntroText.vue?vue&type=template&id=965f78e4&scoped=true&"
import script from "./EditorIntroText.vue?vue&type=script&lang=js&"
export * from "./EditorIntroText.vue?vue&type=script&lang=js&"
import style0 from "./EditorIntroText.vue?vue&type=style&index=0&id=965f78e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965f78e4",
  null
  
)

export default component.exports